import React, { Suspense } from 'react'

const TermsPageBase = React.lazy(() => import('./Terms'))

export const TermsPage = () => (
  <Suspense fallback={null}>
    <TermsPageBase />
  </Suspense>
)
